import { iwocapayTelDisplay } from '../../../../../src/constants.json';
import { useAccountNavigation } from '../../../../hooks/useAccountNavigation';
import { Button } from '../../../components/Button/Button';
import { Card } from '../../../components/Card/Card';
import { buildQueryString } from '../../../utils/queryParams';

export const TooManyAttempts = () => {
  const { navigateToAccount } = useAccountNavigation();

  return (
    <Card title="Whoops, too many attempts">
      <p className="mb-l font-reg">
        Sorry about that, it seems something isn't quite right. We'll be in
        touch as soon as possible.
      </p>
      <p className="mb-l font-reg">
        Give us a call on {iwocapayTelDisplay} if you'd like an update.
      </p>
      <Button
        onClick={() => navigateToAccount(buildQueryString())}
        className="w-full"
      >
        Go to your iwocaPay dashboard
      </Button>
    </Card>
  );
};
